import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function InputFileUpload({
  isIcon,
  lable,
  fileChange,
  size,
  flex,
  btnColor,
}: any) {
  return (
    <Button
      sx={{ p: 1, flex: flex }}
      component="label"
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      startIcon={isIcon && <CloudUploadIcon />}
      size={size}
      color={btnColor}
    >
      {lable}
      <VisuallyHiddenInput type="file" onChange={fileChange} multiple />
    </Button>
  );
}
